import codes from './data/data-code-naf.json'

export function getCodeNafWithLibelle(code: string) {
  if (!code || code.length < 2) return

  const twoFirstCharacteres = getPrefixCodeNaf(code)
  const codeFound = codes.find((c) => c.code_naf === twoFirstCharacteres) || null
  return `${twoFirstCharacteres} - ${codeFound?.libelle_code_naf}`
}

function getPrefixCodeNaf(code: string) {
  if (!code || code.length < 2) return
  return code.slice(0, 2)
}
